import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../shared/buttons/button';
import NavLink from '../shared/buttons/nav-link';

export type ActionsPropsType = {
  hasNextPage: boolean | undefined;
  onFetchNext: any;
};

function Actions({ hasNextPage, onFetchNext }: ActionsPropsType) {
  const [showFinishModal, setShowFinishModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className='grid grid-cols-2 gap-2'>
      <div className='col-span-2 flex flex-col gap-2'>
        {hasNextPage && (
          <Button
            color='green'
            content='بارگذاری بقیه سوالات'
            size='lg'
            onClick={onFetchNext}
            className='mx-auto w-2/3'
          />
        )}
        <NavLink
          to='/results'
          color='yellow'
          content='بازگشت'
          size='lg'
          className='mx-auto w-2/3'
        />
      </div>
    </div>
  );
}

export default Actions;
